import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './PriceButton.css';

const Button = ({ setRatioImage, handleClickEdit, icon, width, isSubmit }) => (
  <div className={s.editButton} onClick={handleClickEdit}>
    <img
      alt=""
      src={setRatioImage(icon, width)}
      width={width}
      className={cx(s.agencyLogo, s.editLogo, { [s.submitButton]: isSubmit })}
    />
  </div>
);

Button.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
  setRatioImage: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  isSubmit: PropTypes.bool,
};

Button.defaultProps = {
  isSubmit: false,
};

export default withStyles(s)(Button);



// WEBPACK FOOTER //
// ./src/desktop/components/PriceBlock/PriceButton/PriceButton.js